interface Props {
  label?: string;
}

export function Spinner({ label }: Props) {
  return (
    <div className="inline-flex flex-col items-center gap-3">
      <div className="np-spinner" aria-hidden>
        <span />
        <span />
        <span />
      </div>
      {label && (
        <div className="font-mono text-[11px] uppercase tracking-folio text-[var(--fg-muted)]">
          {label}
        </div>
      )}
    </div>
  );
}
